module.exports = __webpack_public_path__ + "images/certs-d9417ada69db13a9dcd3c4dc701c578b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/certs.png
 ** module id = 430
 ** module chunks = 0
 **/